import { API_KEY } from "./gameConfig"

interface FindGameResponse {
  gameRef: string | null
}

export const findGame = async (token: string): Promise<string | null> => {
  const response = await fetch(`/api/find-game?token=${token}`, {
    headers: {
      "x-gatsby-app-key": API_KEY || "",
    },
  })
  const result: FindGameResponse = await response.json()
  if (result.gameRef) {
    return result.gameRef
  }
  return null
}
